import type { SessionResponse } from "../../shared/types";
import { SESSION_STATE_COOKIE_NAME } from "../../shared/session";

function readCookie(name: string): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  const prefix = `${name}=`;
  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(prefix));

  return cookie ? cookie.slice(prefix.length) : null;
}

export function readClientSession(): SessionResponse["user"] {
  const rawValue = readCookie(SESSION_STATE_COOKIE_NAME);
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(rawValue)) as SessionResponse["user"];
  } catch {
    return null;
  }
}
